import { useMutation } from "@tanstack/react-query"
import * as queries from '@supabase/queries';

interface User {
    first_name: string;
    last_name: string;
    email: string;
    password: string;
}

export default function useSignUp() {
    return useMutation({
        mutationKey: ['sign_up'],
        mutationFn: async (user: User) => {
            const res = await queries.signUp(
                user.email,
                user.password,
                user.first_name,
                user.last_name
            );
            return res;
        }
    });
}
